import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "hu",
  "use": "hu-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"hu\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#fff\" d=\"M512 512H0V0h512z\" />\n    <path fill=\"#388d00\" d=\"M512 512H0V341.3h512z\" />\n    <path fill=\"#d43516\" d=\"M512 170.8H0V.1h512z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/hu.svg
// module id = null
// module chunks = 